import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'

import './RechtlichesOverview.css'
import './MRechtlichesOverview.css'


export default function RechtlichesOverview() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Impressum</title>
                <meta property="og:title" content="Impressum" />
                <meta property="og:description" content="Hier findest du unser Impressum" />
                <meta name="description" content="Hier findest du unser Impressum" />
            </Helmet>
            <section className='sec_next' id='sec_next--rechtliches'>
                <div className='sec_next_cont' id="sec_next--rechtliches--cont" style={{ wordBreak: "break-word" }}>
                    <br />
                    <h2>Rechtliche Hinweise</h2>
                    <br />
                    <p>Hier findest du alle wichtigen Informationen zu Verantwortlichen, Datenschutz, Allgemeinen Geschäftsbedingungen oder Barrierefreiheit.</p>
                    <ul className='rechtliches_list'>
                        <li><a href='/rechtliches/impressum' className='sec_next_link'>Impressum</a></li>
                        <li><a href='/rechtliches/datenschutz' className='sec_next_link'>Datenschutzerklärung</a></li>
                        <li><a href='/rechtliches/agb' className='sec_next_link'>Allgemeine Geschäftsbedingungen (AGB)</a></li>
                        <li><a href='/rechtliches/barrierefreiheit' className='sec_next_link'>Erklärung zur Barrierefreiheit</a></li>
                        <li><a href='/rechtliches/diversity' className='sec_next_link'>Erklärung zu Diversity</a></li>
                    </ul>

                    <h3 className='rechtliches_subheading'>Datenschutzerklärungen für Apps</h3>
                    <ul className='rechtliches_list rechtliches_list--apps'>
                        <li><a href='/rechtliches/services/blackmamba/datenschutz' className='sec_next_link'>Datenschutzerklärung App „Black Mamba Tracker“</a></li>
                    </ul>
                </div>
            </section >

            <MainFooter />
        </div >
    )
}